import { ReactElement } from 'react';

import { PeriodicTask, TechnicalTask } from '@/modules/home';
import { IHome } from '@/modules/home/types';

interface IProps {
  operation: IHome.ITimelineOperationItem;
}
const OperationTask = ({ operation }: IProps): ReactElement => {
  return operation.type === 'technical' ? (
    <TechnicalTask technicalTask={operation} />
  ) : (
    <PeriodicTask periodicTask={operation} />
  );
};
export { OperationTask };
